export const lastTimeSort = (state, callback, paramsKey = "queryRef") => {
  const lastTimeEvent = ({ order, sortBy = "last_modified_time", lastTime }) => {
    state[paramsKey].current = 1;
    state[paramsKey].sortBy = sortBy;

    if (order != "") {
      state[paramsKey].sortOrder = order;
    } else {
      // state[paramsKey].sortBy = "id";
      state[paramsKey].sortOrder = "desc";
    }
    if (lastTime.length > 0) {
      [state[paramsKey].editStart, state[paramsKey].editEnd] = lastTime;
      state[paramsKey].editStart = `${state[paramsKey].editStart} 00:00:00`;
      state[paramsKey].editEnd = `${state[paramsKey].editEnd} 23:59:59`;
    } else {
      state[paramsKey].editStart = "";
      state[paramsKey].editEnd = "";
    }
    callback();
  };
  const resetSort = () => {
    state[paramsKey].sortBy = "create_time";
    state[paramsKey].sortOrder = "desc";
    state[paramsKey].editStart = "";
    state[paramsKey].editEnd = "";
  };
  return {
    lastTimeEvent,
    resetSort,
  };
};
